import { Skeleton } from "@/components/ui/skeleton";

export function NotificationSkeleton() {
  return (
    <div className="flex gap-4 px-4 py-4">
      <div className="relative shrink-0">
        <Skeleton className="size-8 rounded-full" />
        <Skeleton className="absolute -bottom-1 -right-1 size-5" />
      </div>
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-2.5 w-16" />
      </div>
    </div>
  );
}
